<script>
    import R, {LOADER} from "../lib/requests";
    import app from "../stores/app";
    import user from "../stores/user";
    import cart from "../stores/cart";
    import Notifier from "../stores/notifier";
    import Alerts from "../stores/alerts";
    import ProductModal from "../product/ProductModal.svelte";

    let products = null;
    let productId = null;

    const load = () => {
        const onSuccess = result => {
            products = result;
            products.map(item => {
                item.requires_account = ~~item.requires_account;
                item.requires_subscription = ~~item.requires_subscription;
            });
        }

        const onFailure = err => {
        };

        R.handle(R.product.index, [], onSuccess, onFailure, LOADER.PAGE);
    }

    const addToCart = product => {
        if (product.requires_account && !$user.token) {
            Alerts.accountRequired('', "Για την αγορά αυτού του προϊόντος απαιτείται η σύνδεση με τον λογαριασμό σας στον Π.Κ.Σ.");
            return;
        }
        cart.addToCart(product);
        cart.toggle(true);
        Notifier.showMessage("Το προϊόν προστέθηκε στο καλάθι αγορών");
    }

    const onProductClick = (product) => {
        productId = product.id;
    }

    load();
</script>

<div class="container">
    <div class="mb-5">
        <h1>Προϊόντα - Υπηρεσίες</h1>
        <div class="heading-separator"></div>
    </div>

    {#if products != null}
        <div class="row products">
            {#each products as product}
                <div class="col-xl-3 col-lg-4 col-md-6">
                    <div class="product mb-5">
                        <a href="/product/{ product.id }/{ product.slug }" class="image mb-3"
                           class:no-image={ ! product.image }>
                            {#if product.image}
                                <img src="{ $app.product_image_url }{ product.image }" alt="product image">
                            {:else}
                                <img src="/assets/images/product-logo.png" alt="product logo">
                            {/if}
                        </a>
                        <h2 class="title"><a href="/product/{ product.id }/{ product.slug }">{ product.name }</a></h2>
                        {#if $user.token}
                            <div class="price mb-3">€{ product.price }</div>
                        {/if}
                        <button class="btn btn-success btn-block" title="προσθήκη στο καλάθι"
                                on:click|preventDefault|stopPropagation={ () => onProductClick(product) }>
                            προσθήκη
                        </button>
                    </div>
                </div>
            {/each}
        </div>
    {/if}
</div>

{#if productId}
    <ProductModal bind:productId={ productId }/>
{/if}

<style>
    .products .product {
        position: relative;
        padding: 20px;
        border: 1px solid #EAEAEA;
    }

    .products .product:hover {
        box-shadow: 0 4px 4px rgba(0, 0, 0, 0.15);
    }

    .products .product .image {
        display: flex;
        align-items: center;
        /*background: #f4f5f5;*/
        height: 380px;
        overflow: hidden;
        cursor: pointer;
    }

    .products .product .image img {
        width: 100%;
    }

    .products .product .image.no-image {
        padding: 30px;
    }

    .products .product .image.no-image img {
        opacity: 0.5;
    }

    .product .title {
        display: flex;
        align-items: center;
        height: 40px;
        font-family: var(--secondary-font);
        font-size: 1rem;
        font-weight: normal;
        margin: 0;
    }

    .product .title a {
        color: inherit;
    }

    .product .price {
        font-weight: 600;
        color: #696969;
    }

    @media (max-width: 576px) {
        .products .product .image {
            height: auto;
        }
    }
</style>